import axiosInstance from "../../config/axiosInstance";

const getEventsRequest = async () => {
  return await axiosInstance.dillApi().get("/operations/events");
};

export default getEventsRequest;
